import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { UserPreferencesSaveRequest } from '@/main/models/request/userPreferencesRequest';
import { UserPreferencesSaveResponse } from '@/main/models/response/userPreferencesResponse';

export abstract class IUserPreferencesApi {
  abstract getUserPreferences(): Promise<AxiosResponse<Result<any[]>>>;

  abstract saveUserPreferences(request: UserPreferencesSaveRequest): Promise<AxiosResponse<Result<UserPreferencesSaveResponse>>>;
}